import React from 'react'
import { mergeClassnames } from '@mote/helpers/dom'
import { Block, CloseButton } from '@mote/ui'
import styled, { th } from '@xstyled/styled-components'

export const DraggableRecorderLayout = React.forwardRef(
  ({ children, headerProps = {}, contentProps = {}, ...rest }, ref) => {
    const {
      children: headerChildren,
      className: headerClassName,
      onClose,
      ...restHeaderProps
    } = headerProps

    return (
      <Root
        ref={ref}
        {...rest}
        id='draggable-recorder'
        role='dialog'
        tabIndex={-1}
        aria-modal={true}
        aria-labelledby='draggable-recorder--header'
        aria-describedby='draggable-recorder--content'
      >
        {headerChildren && (
          <Header
            {...restHeaderProps}
            className={mergeClassnames('draggable-handle', headerClassName)}
            id='draggable-recorder--header'
          >
            {headerChildren}
            {onClose && (
              <CloseButton
                size='md'
                position='absolute'
                right='10px'
                onClick={onClose}
              />
            )}
          </Header>
        )}
        <Container
          align='center'
          justify='center'
          gap={32}
          {...contentProps}
          id='draggable-recorder--content'
        >
          {children}
        </Container>
      </Root>
    )
  }
)

export const Root = styled.section`
  position: relative;
  width: 340px;
  height: 100%;
  max-height: 300px;
  background: white;
  border-radius: 10px;
  outline: none !important;
  box-shadow: xl;
  border: 1px solid ${th.color('grey.l2')};
`

const Header = styled.header`
  position: relative;
  font-family: DM Sans;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 21px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px 0;
  border-bottom: 1px solid ${th.color('grey.l2')};
`

export const Container = styled(Block)`
  height: 250px;
  box-sizing: border-box;
  outline: none !important;
`
